/*
  Google Reviews Pro - carousel / filter / read-more controller.
  Rebuilt to avoid the page-jump bug: every scroll action is scoped to the
  carousel's own horizontal scroll container (track.scrollTo / scrollBy),
  never to scrollIntoView(), which is what used to yank the whole page
  toward the section while swiping.
*/
(function () {
  var initialized = new WeakSet();

  function initReviewsPro(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    var track = root.querySelector('[data-grp-track]');
    var prev = root.querySelector('[data-grp-prev]');
    var next = root.querySelector('[data-grp-next]');
    var dotsWrap = root.querySelector('[data-grp-dots]');
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-grp-filter]'));
    var isCarousel = root.dataset.layout === 'carousel';
    var autoplay = root.dataset.autoplay === 'true';
    var autoplaySeconds = parseFloat(root.dataset.autoplaySeconds || '5');
    var timer = null;
    var dots = [];
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function allCards() {
      return Array.prototype.slice.call(track.children).filter(function (el) { return !el.hasAttribute('data-grp-clone'); });
    }

    function visibleCards() {
      return allCards().filter(function (card) {
        return card.style.display !== 'none';
      });
    }

    function pageSize() {
      var cards = visibleCards();
      if (!cards.length || !track) return 1;
      var trackWidth = track.clientWidth;
      var cardWidth = cards[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      var size = Math.max(1, Math.round((trackWidth + gap) / (cardWidth + gap)));
      return size;
    }

    function currentPage() {
      if (!track) return 0;
      var cards = visibleCards();
      if (!cards.length) return 0;
      var first = cards[0];
      var step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      if (!step) return 0;
      return Math.round(track.scrollLeft / (step * pageSize()));
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var cards = visibleCards();
      var size = pageSize();
      var pages = Math.max(1, Math.ceil(cards.length / size));
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to review page ' + (i + 1));
        b.addEventListener('click', function (idx) {
          return function () {
            stopAutoplay();
            goToPage(idx);
            startAutoplay();
          };
        }(i));
        dotsWrap.appendChild(b);
        dots.push(b);
      }
      updateDots();
    }

    function updateDots() {
      if (!dots.length) return;
      var index = Math.min(dots.length - 1, Math.max(0, currentPage()));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (prev) prev.disabled = track.scrollLeft <= 4 && !isLoopable();
      if (next) next.disabled = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth && !isLoopable();
    }

    function isLoopable() {
      return true;
    }

    // Scoped, safe scroll - this NEVER touches the document/page scroll
    // position, only the track element's own horizontal scrollLeft.
    function goToPage(index) {
      var cards = visibleCards();
      if (!cards.length || !track) return;
      var size = pageSize();
      var pages = Math.max(1, Math.ceil(cards.length / size));
      var clamped = Math.max(0, Math.min(pages - 1, index));
      var target = cards[Math.min(cards.length - 1, clamped * size)];
      if (!target) return;
      var left = target.offsetLeft - track.offsetLeft;
      track.scrollTo({ left: left, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    }

    function move(direction) {
      if (!isCarousel) return;
      var cards = visibleCards();
      if (!cards.length) return;
      var pages = Math.max(1, Math.ceil(cards.length / pageSize()));
      var target = currentPage() + direction;
      if (target < 0) target = pages - 1;
      if (target > pages - 1) target = 0;
      goToPage(target);
    }

    var marqueeFrame = null, marqueeReady = false; function setupMarquee() { if (marqueeReady || !track) return; var cards = allCards(); if (cards.length < 2) return; cards.forEach(function (c) { var clone = c.cloneNode(true); clone.setAttribute('data-grp-clone', 'true'); clone.setAttribute('aria-hidden', 'true'); Array.prototype.slice.call(clone.querySelectorAll('a,button,input,textarea,select,[tabindex]')).forEach(function (f) { f.setAttribute('tabindex', '-1'); }); track.appendChild(clone); }); marqueeReady = true; } function marqueeStep(ts) { if (!track) { marqueeFrame = null; return; } var cycleWidth = track.scrollWidth / 2; if (!marqueeStep.last) marqueeStep.last = ts; var dt = ts - marqueeStep.last; marqueeStep.last = ts; var speed = cycleWidth / (Math.max(2, autoplaySeconds) * 1000); track.scrollLeft += speed * dt; if (track.scrollLeft >= cycleWidth) track.scrollLeft -= cycleWidth; marqueeFrame = window.requestAnimationFrame(marqueeStep); } function startAutoplay() {
      if (!autoplay || !isCarousel || prefersReducedMotion) return;
      stopAutoplay();
      if (allCards().length < 2) return; timer = window.setInterval(function () {
        move(1);
      }, Math.max(2000, autoplaySeconds * 1000));
    }

    function stopAutoplay() {
      if (marqueeFrame) { window.cancelAnimationFrame(marqueeFrame); marqueeFrame = null; if (track) track.style.scrollSnapType = ''; } if (timer) window.clearInterval(timer);
      timer = null;
    }

    if (prev) prev.addEventListener('click', function () { stopAutoplay(); move(-1); startAutoplay(); });
    if (next) next.addEventListener('click', function () { stopAutoplay(); move(1); startAutoplay(); });

    // Native swipe/scroll only ever updates the dot indicator - it never
    // re-triggers a scroll of its own, so there is nothing here that can
    // propagate up to the page.
    var scrollFrame = null;
    if (track) {
      track.addEventListener('scroll', function () {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(updateDots);
      }, { passive: true });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) startAutoplay();
          else stopAutoplay();
        });
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      startAutoplay();
    }

    // Rating filter chips
    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.dataset.grpFilter;
        filterButtons.forEach(function (b) { b.classList.toggle('is-active', b === button); });
        allCards().forEach(function (card) {
          var show = filter === '0' || card.dataset.rating === filter;
          card.style.display = show ? '' : 'none';
        });
        // Reset to the start of the (filtered) track - scoped to the
        // track element only, never the page.
        track.scrollTo({ left: 0, behavior: 'auto' });
        buildDots();
      });
    });

    // Read more / read less
    function syncReadMoreButtons(){root.querySelectorAll('[data-grp-readmore]').forEach(function(btn){var t=btn.previousElementSibling;if(!t||!t.hasAttribute('data-grp-text'))return;if(t.classList.contains('is-expanded')){btn.hidden=false;return;}btn.hidden=!(t.scrollHeight-t.clientHeight>1);});} syncReadMoreButtons(); root.querySelectorAll('[data-grp-readmore]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var textEl = btn.previousElementSibling;
        if (!textEl || !textEl.hasAttribute('data-grp-text')) return;
        var expanded = textEl.classList.toggle('is-expanded');
        btn.textContent = expanded ? btn.dataset.less : btn.dataset.more;
      });
    });

    buildDots();
    startAutoplay();

    var resizeFrame = null;
    window.addEventListener('resize', function () {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () { buildDots(); syncReadMoreButtons(); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-google-reviews-pro]').forEach(initReviewsPro);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
